import { useCallback } from "react";

import { Divider } from "@/components/General/Divider/divider.component";
import { StoreCard } from "@/components/Store/StoreSearch/components/list/storeCard/storeCard.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { parseCountryToISO } from "@/utils/textUtils";

import { getStoreInfo } from "../../utils/storeInfo";
import "./storeFlyout.scss";

import { CloudStore } from "@omni/types/api/store/cloud/store.model";

import { Config } from "@/utils/config.utils";

import { useStoreFullName } from "../../utils/useStoreFullName.hook";

export type StoreFlyoutProps = {
    store?: CloudStore | null;
    link: string;
};

const StoreFlyout = ({ store }: StoreFlyoutProps) => {
    const { t } = useGranite();

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    const getStoreUrl = useCallback(
        (storeDetail: CloudStore) => {
            return `${Config.pages.stores}${storeDetail.code}/`;
        },
        [store]
    );

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    const getOpenInfo = useCallback(
        (storeDetails: CloudStore) => getStoreInfo(storeDetails, t),
        [store]
    );

    const storeFullName = useStoreFullName(store);

    if (!store) {
        return null;
    }

    const storeStatus = getOpenInfo(store);

    const storeAddressLines = [
        `${store.address.streetName || ""} ${store.address.streetNumber || ""}`,
        `${store.address.postalCode || ""} ${store.address.town || ""}`
    ];

    return (
        <div className="store-flyout">
            <Divider
                marginTop={"2"}
                className="mb-3"
            />
            <h3 className="text-primary mx-3">
                {t("header.navigation.shopfinder.title")}
            </h3>
            <StoreCard
                className="p-0 mx-3"
                isOpen={storeStatus.isOpen}
                name={storeFullName || ""}
                addressLines={storeAddressLines}
                phone={store.address.phone1}
                countryCode={parseCountryToISO(store.address.country)}
                openClosesAt={storeStatus.text2}
            />
            <p className="store-flyout__show-store mt-2 mb-0 mx-3">
                <a href={getStoreUrl(store)}>
                    {t("header.navigation.shopfinder.showShop")}
                </a>
            </p>
            <Divider className="m-3" />
            <p className={"my-0 mx-3"}>
                <a
                    className="btn btn-outline-primary w-100"
                    href={Config.pages.stores}
                >
                    {t("header.navigation.shopfinder.showAll")}
                </a>
            </p>
        </div>
    );
};

export { StoreFlyout };
